import { Tab, Tabs as MuiTabs, Theme, Stack } from '@mui/material';

import { FC, SyntheticEvent } from 'react';
import { createUseStyles } from 'react-jss';
import { TabBarItem } from './helpers';
import Icon from '../icon';

interface Props {
  items: TabBarItem[];
  tabIndex: number;
  onTabChange?: (_event: SyntheticEvent, tabIndex: number) => void;
}

const useStyles = createUseStyles((theme: Theme) => ({
  tabs: {
    minHeight: 0,
    flexShrink: 0,
    '& .MuiTabs-flexContainer': {
      gap: 28,
    },
    '& .MuiTab-root': {
      textTransform: 'none',
      minWidth: 0,
      minHeight: 0,
      padding: '0 2px 12px',
      color: theme.palette.darkGray,
      '&:hover, &.Mui-selected': {
        color: theme.palette.primary.main,
      },
    },
  },
}));

const a11yProps = (index: number) => {
  return {
    id: `full-width-tab-${index}`,
    'aria-controls': `full-width-tabpanel-${index}`,
  };
};

const TabBar: FC<Props> = ({ items, tabIndex, onTabChange }) => {
  const styles = useStyles();

  return (
    <MuiTabs value={tabIndex} onChange={onTabChange} className={styles.tabs}>
      {items.map(({ key, label, disabled, icon }, index) => (
        <Tab
          key={key}
          label={
            icon ? (
              <Stack direction="row" alignItems="center" justifyContent="flex-start" gap={1}>
                <Icon name={icon} size="small" /> {label}
              </Stack>
            ) : (
              label
            )
          }
          {...a11yProps(index)}
          disabled={disabled}
          disableRipple
        />
      ))}
    </MuiTabs>
  );
};

export default TabBar;
